import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {BookingExtraTable} from './table/BookingExtraTable'
import {BookingExtraEditModal} from './booking-extras-edit-modal/BookingExtraEditModal'
import {KTCard} from '../../../../_dashboard/helpers'
import {BookingExtraListHeader} from './header/BookingExtraListHeader'
import { ToastContainer } from 'react-toastify'

const BookingExtraList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <ToastContainer/>
        <BookingExtraListHeader />
        <BookingExtraTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <BookingExtraEditModal />}
    </>
  )
}

const BookingExtraListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <BookingExtraList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {BookingExtraListWrapper}
